import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: "root",
})
// The ClearCacheService is responsible for managing cache clearing events in the application.
// It provides an observable that components can subscribe to in order to be notified when a cache clear event occurs,
// allowing them to perform necessary actions such as logging out the user or resetting application state.
export class ClearCacheService {
    private readonly logoutSubject: Subject<void> = new Subject<void>();
    public readonly logout$: Observable<void> = this.logoutSubject.asObservable();

    public clearCache(): void {
        this.logoutSubject.next();
    }
}
